import { Directive, Host, Input } from '@angular/core';

@Directive({
  selector: '[offClick]',
  host: {
    '(click)': 'onClick($event)',
  }
})

export class OffClickDirective {
  @Input('offClick') offClickHandler;

  constructor() {
  }

  ngOnInit() {
    let self = this;
    setTimeout(() => { document.addEventListener('click', self.offClickHandler); }, 0);
  }

  ngOnDestroy() {
    let self = this;
    document.removeEventListener('click', self.offClickHandler);
  }

  onClick($event) {
    $event.stopPropagation();
  }
}
